import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TokenExpirationWarning from '../components/TokenExpirationWarning';

const MainLayout = () => {
  return (
    <div className="app-container">
      <Sidebar />
      <main className="main-content">
        <div className="content-wrapper">
          <Outlet />
        </div>
      </main>
      <TokenExpirationWarning />
    </div>
  );
};

export default MainLayout; 